"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var utilities_1 = require("@fluentui/utilities");
var Link_base_1 = require("./Link.base");
var Link_styles_1 = require("./Link.styles");
exports.Link = utilities_1.styled(Link_base_1.LinkBase, Link_styles_1.getStyles, undefined, {
    scope: 'Link',
});
//# sourceMappingURL=Link.js.map